import { Redirect, RouteComponentProps, Router } from '@reach/router';
import React, { ComponentType } from 'react';
import { LoadedEditor } from './detail/editor/loaded-editor.component';
import { List } from './list/list.component';

export const Course: ComponentType<RouteComponentProps> = (props) => {
  return (
    <>
      <Router className="router">
        <List path="list" />
        <LoadedEditor path=":id/edit" mode="update" />
        <LoadedEditor path="create" mode="create" />
        <Redirect noThrow from="/" to="list" />
      </Router>
    </>
  );
};
